module.exports = __webpack_public_path__ + "./docs/img/big-icon-references.38d3f13f93fcfb6897a63f1e9ea89a17.svg";